import axios from 'axios';

// const api = axios.create({
//     timeout: 25000,
//     headers: {
//         'Content-Type': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest',
//     },
// });

const api = axios.create();

export default api;
